import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

export default function FailedLayout({message, reason}: {message: string; reason: string}): JSX.Element {
  return (
    <div className={css(styles.wrapper)}>
      <InlineBanner bannerType={InlineBannerType.ERROR} text={message} supportingInfo={reason} />
    </div>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    padding: '9px 12px',
  },
});
